import { Component, OnInit, effect, inject } from '@angular/core';
import { PartnerService } from '../service/partner.service';
import { Merchant, MerchantResponse } from '../../common/models/shops.model';
import { SharedSignalsService } from '../../common/services/shared-signals.service';

@Component({
  selector: 'taly-shops',
  templateUrl: './shops.component.html',
  styleUrls: ['./shops.component.scss'],
  standalone: false, // Angular 20 recommendation
})
export class ShopsComponent implements OnInit {
  shopList: Merchant[] = [];
  textDirection: string = 'ltr';
  transferSignal = inject(SharedSignalsService);
  partnerService = inject(PartnerService);

  currentPage: number = 0;
  pageSize: number = 8;
  totalPages: number = 0;
  totalRecords: number = 0;
  isLoadingStarted: boolean = false;
  showLoadMore: boolean = true;

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 401);
    this.getShops();
  }

  getShops(): void {
    this.isLoadingStarted = true;
    const param = `page=${this.currentPage}&size=${this.pageSize}`;

    this.partnerService.getShopsList(param).subscribe({
      next: (resp: MerchantResponse) => {
        const records = resp?.records ?? [];

        // Append new records if existing list is non-empty
        this.shopList = [...this.shopList, ...records];

        // Update pagination info safely
        this.currentPage = resp?.currentPage ?? this.currentPage;
        this.totalPages = resp?.totalPages ?? this.totalPages;
        this.totalRecords = resp?.totalRecords ?? this.totalRecords;

        // Determine if "Load More" button should be visible
        this.showLoadMore = this.currentPage + 1 < this.totalPages;
      },
      error: (err) => {
        const message = err?.message ?? 'Error fetching shops';
        this.transferSignal.showMessage('error', message);
      },
      complete: () => {
        this.isLoadingStarted = false;
      },
    });
  }

  loadMoreShops(): void {
    if (this.currentPage < this.totalPages) {
      this.isLoadingStarted = true;
      this.currentPage++;
      this.getShops();
    }
  }

  handleImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/default-shops.svg';
  }
}
